import { TFundTransactionType } from '@/services/apis/fund/types';

export const getFundTransactionTypeTitle = (type: TFundTransactionType) => {
  switch (type) {
    case 'Decomposition':
      return 'تجزیه واحد‌ها';
    case 'Redemption':
      return 'فروش';
    case 'Issuance':
    default:
      return 'خرید';
  }
};
